/**
 * The timeline ruler: where its labels go, and how wide the track must be for
 * them to be read.
 *
 * The track used to be exactly as wide as the window, whatever the video's
 * length. That read fine on a one-minute video and ran every label into the
 * next on a five-minute one: twenty "0:15.00" labels in under 900px is less
 * room per label than the label itself takes. Now the track has a floor, and
 * past it the timeline scrolls rather than squeezing.
 */

/** Pixels from one label's centre to the next. "10:00.00" at 10px is about 45px; the rest is the gap. */
export const MIN_LABEL_SPACING = 64;

/** Seconds between ruler labels: every 15, or every 5 on a short video. */
export function rulerStep(durationSeconds: number): number {
  return durationSeconds > 60 ? 15 : 5;
}

/** The narrowest the track can be with every label still clear of the next. */
export function rulerMinWidth(durationSeconds: number): number {
  return Math.ceil((Math.max(durationSeconds, 0) / rulerStep(durationSeconds)) * MIN_LABEL_SPACING);
}
